import { render } from "./followList.vue?vue&type=template&id=ee41fd68&scoped=true"
import script from "./followList.vue?vue&type=script&lang=js"
export * from "./followList.vue?vue&type=script&lang=js"

import "./followList.vue?vue&type=style&index=0&id=ee41fd68&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee41fd68"]])

export default __exports__